import Input from "components/Elements/Input";
const TextField = ({ name, param, value, onChange = () => {} }) => {
  return (
    <>
      <Input type="text" name={name} value={value} onChange={onChange} />
    </>
  );
};

export default TextField;
